import SVG, { CustomSVGWithDirection } from '@/src/components/common/SVG/SVG'

export default function SVGChevron({ direction, ..._ }: CustomSVGWithDirection) {
  if (!direction) direction = 'right'

  const rotation = {
    up: 270,
    down: 90,
    left: 180,
    right: 0,
  }[direction]

  _.width = _.width ?? 8
  _.height = _.height ?? 12
  _.style = { ..._.style, transform: `rotate(${rotation}deg)` }

  return (
    <SVG viewBox="0 0 8 12" {..._}>
      <path d="M1.41 0L0 1.41L4.58 6L0 10.59L1.41 12L7.41 6L1.41 0Z" fill="currentcolor" />
    </SVG>
  )
}
